module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "city",
    staticClass: "wxc-city weex-ct weex-div",
    style: (_vm._px2rem(_vm.cityExtendStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('wxc-searchbar', _vm._b({
    ref: "wxc-searchbar",
    attrs: {
      "data-evt-wxcSearchbarInputOnInput": "",
      "data-evt-wxcSearchbarInputReturned": "",
      "data-evt-wxcSearchbarCancelClicked": ""
    },
    on: {
      "wxcSearchbarInputOnInput": _vm.onInput,
      "wxcSearchbarInputReturned": _vm.onSubmit,
      "wxcSearchbarCancelClicked": _vm.onCancel
    }
  }, 'wxc-searchbar', _vm.mergeInputConfig, false)), _vm._v(" "), (_vm.showTab) ? _c('wxc-tab', {
    ref: "wxc-tab",
    attrs: {
      "data-evt-wxcTabSwitch": ""
    },
    on: {
      "wxcTabSwitch": _vm.onTabSwitch
    }
  }) : _vm._e(), _vm._v(" "), _c('wxc-indexlist', {
    attrs: {
      "normal-list": _vm.normalList,
      "hot-list-config": _vm.hotListConfig,
      "nav-style": {
        top: '24px'
      },
      "height": _vm.listHeight,
      "show-index": _vm.showIndex,
      "only-show-list": !_vm.showNavHeader || _vm.onlyShowList,
      "city-location-config": _vm.currentCityLocationConfig,
      "data-evt-wxcIndexlistItemClicked": ""
    },
    on: {
      "wxcIndexlistItemClicked": _vm.onItemClick
    }
  }), _vm._v(" "), (_vm.showError) ? _c('wxc-result', {
    attrs: {
      "type": "noGoods",
      "wrap-style": {
        top: '84px'
      },
      "show": true,
      "customSet": _vm.result
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5797e3c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5797e3c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-city/index.vue
// module id = 224
// module chunks = 0 1